var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.18,
    height: 30,
    viewBox: "0 0 161.18 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.721 -7.698)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.721 7.698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.611,7.7l-1.756,2.1,4.642,3.89H19.656L12.476,7.7l-1.756,2.1L17.9,15.808V29.614l2.735,2.281V16.468H47.978V34.914H19.691L12.476,28.9,10.721,31l8,6.7H50.714V14.453Z",
    transform: "translate(-10.721 -7.698)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.106,
    height: 1.966,
    transform: "translate(14.888 13.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.107,
    height: 1.966,
    transform: "translate(22.027 13.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.106,
    height: 1.966,
    transform: "translate(29.237 13.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.106,
    height: 1.966,
    transform: "translate(14.888 20.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.107,
    height: 1.966,
    transform: "translate(22.027 20.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.106,
    height: 1.966,
    transform: "translate(29.237 20.089)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.237 18.399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.418,41.86h8.891v2.122h-3.38V53.17h-2.184V43.982h-3.327Z",
    transform: "translate(-162.418 -41.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.005,50.789h2.1v8.365h-2.1V58.27a4.138,4.138,0,0,1-1.232.842,3.472,3.472,0,0,1-1.341.257,3.721,3.721,0,0,1-2.8-1.257,4.382,4.382,0,0,1-1.183-3.126,4.5,4.5,0,0,1,1.144-3.176,3.646,3.646,0,0,1,2.78-1.238,3.536,3.536,0,0,1,1.413.285,3.842,3.842,0,0,1,1.222.853ZM195.8,52.512a2.121,2.121,0,0,0-1.617.688,2.746,2.746,0,0,0,.011,3.548,2.121,2.121,0,0,0,1.612.7,2.163,2.163,0,0,0,1.64-.688,2.52,2.52,0,0,0,.651-1.8,2.444,2.444,0,0,0-.651-1.768A2.188,2.188,0,0,0,195.8,52.512Z",
    transform: "translate(-182.354 -47.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.941,45.168V48a3.93,3.93,0,0,1,1.23-.853,3.553,3.553,0,0,1,1.415-.285A3.655,3.655,0,0,1,233.37,48.1a4.5,4.5,0,0,1,1.145,3.176,4.387,4.387,0,0,1-1.184,3.126,3.729,3.729,0,0,1-2.806,1.257,3.507,3.507,0,0,1-1.346-.257,4.127,4.127,0,0,1-1.238-.842v.885h-2.084V45.168Zm2.207,3.632a2.187,2.187,0,0,0-1.645.677,2.436,2.436,0,0,0-.653,1.768,2.512,2.512,0,0,0,.653,1.8,2.171,2.171,0,0,0,1.645.688,2.133,2.133,0,0,0,1.618-.7,2.5,2.5,0,0,0,.657-1.783,2.475,2.475,0,0,0-.646-1.765A2.141,2.141,0,0,0,230.148,48.8Z",
    transform: "translate(-205.986 -44.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.309,45.168h2.1V55.442h-2.1Z",
    transform: "translate(-228.273 -44.132)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.619,55.58h-6.743A2.243,2.243,0,0,0,272.657,57a2.448,2.448,0,0,0,1.618.526A2.8,2.8,0,0,0,276.3,56.7l1.769.831a4.165,4.165,0,0,1-1.584,1.388,4.935,4.935,0,0,1-2.191.45,4.332,4.332,0,0,1-3.207-1.242,4.227,4.227,0,0,1-1.237-3.111,4.372,4.372,0,0,1,1.233-3.179,4.151,4.151,0,0,1,3.1-1.265,4.3,4.3,0,0,1,3.214,1.265,4.576,4.576,0,0,1,1.238,3.342Zm-2.1-1.654a2.1,2.1,0,0,0-.821-1.138,2.374,2.374,0,0,0-1.42-.439,2.512,2.512,0,0,0-1.54.493,2.747,2.747,0,0,0-.771,1.083Z",
    transform: "translate(-236.197 -47.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.288,41.86h2.1l2.622,7.889,2.646-7.889h2.1l1.9,11.31h-2.082l-1.213-7.143-2.4,7.143h-1.9l-2.382-7.143-1.242,7.143h-2.1Z",
    transform: "translate(-258.505 -41.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.913,50.789h2.1v8.365h-2.1V58.27a4.147,4.147,0,0,1-1.232.842,3.474,3.474,0,0,1-1.341.257,3.719,3.719,0,0,1-2.8-1.257,4.381,4.381,0,0,1-1.183-3.126,4.5,4.5,0,0,1,1.144-3.176,3.647,3.647,0,0,1,2.78-1.238,3.538,3.538,0,0,1,1.413.285,3.842,3.842,0,0,1,1.222.853Zm-2.206,1.723a2.122,2.122,0,0,0-1.617.688,2.747,2.747,0,0,0,.012,3.548,2.122,2.122,0,0,0,1.612.7,2.165,2.165,0,0,0,1.641-.688,2.521,2.521,0,0,0,.65-1.8,2.445,2.445,0,0,0-.65-1.768A2.189,2.189,0,0,0,352.707,52.512Z",
    transform: "translate(-290.114 -47.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.766,50.789h2.1v.858a5.026,5.026,0,0,1,1.293-.838,3.129,3.129,0,0,1,1.186-.235,2.876,2.876,0,0,1,2.112.87,2.985,2.985,0,0,1,.729,2.183v5.529H388.11V55.491a9.276,9.276,0,0,0-.134-1.989,1.362,1.362,0,0,0-.469-.748,1.309,1.309,0,0,0-.824-.258,1.543,1.543,0,0,0-1.093.427,2.275,2.275,0,0,0-.632,1.179,9.511,9.511,0,0,0-.092,1.7v3.357h-2.1Z",
    transform: "translate(-313.746 -47.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.267,50.789h2.1v8.365h-2.1V58.27a4.123,4.123,0,0,1-1.232.842,3.47,3.47,0,0,1-1.34.257,3.723,3.723,0,0,1-2.8-1.257,4.384,4.384,0,0,1-1.182-3.126,4.5,4.5,0,0,1,1.144-3.176,3.646,3.646,0,0,1,2.779-1.238,3.539,3.539,0,0,1,1.413.285,3.84,3.84,0,0,1,1.221.853Zm-2.206,1.723a2.122,2.122,0,0,0-1.617.688,2.746,2.746,0,0,0,.012,3.548,2.121,2.121,0,0,0,1.612.7,2.164,2.164,0,0,0,1.641-.688,2.519,2.519,0,0,0,.651-1.8,2.443,2.443,0,0,0-.651-1.768A2.186,2.186,0,0,0,416.061,52.512Z",
    transform: "translate(-333.624 -47.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.493,50.789h2.092v7.166a4.736,4.736,0,0,1-.854,3.121,4.275,4.275,0,0,1-3.453,1.353,6.046,6.046,0,0,1-2.067-.307,3.748,3.748,0,0,1-1.415-.9,3.7,3.7,0,0,1-.853-1.45h2.314a1.911,1.911,0,0,0,.792.535,3.28,3.28,0,0,0,1.146.181,3.022,3.022,0,0,0,1.36-.262,1.587,1.587,0,0,0,.727-.677,3.454,3.454,0,0,0,.211-1.431,3.452,3.452,0,0,1-1.161.8,3.693,3.693,0,0,1-1.377.243,3.784,3.784,0,0,1-2.845-1.215,4.714,4.714,0,0,1,.07-6.273,3.665,3.665,0,0,1,2.66-1.093,3.53,3.53,0,0,1,1.365.266,4.334,4.334,0,0,1,1.287.872Zm-2.176,1.745a2.183,2.183,0,0,0-1.637.665,2.3,2.3,0,0,0-.647,1.673,2.336,2.336,0,0,0,.662,1.714,2.238,2.238,0,0,0,1.66.668,2.147,2.147,0,0,0,1.612-.654,2.357,2.357,0,0,0,.633-1.713,2.328,2.328,0,0,0-.637-1.7A2.2,2.2,0,0,0,449.317,52.535Z",
    transform: "translate(-356.448 -47.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.828,55.58h-6.743A2.242,2.242,0,0,0,480.865,57a2.448,2.448,0,0,0,1.619.526,2.794,2.794,0,0,0,2.021-.823l1.769.831a4.164,4.164,0,0,1-1.585,1.388,4.93,4.93,0,0,1-2.19.45,4.333,4.333,0,0,1-3.207-1.242,4.226,4.226,0,0,1-1.237-3.111,4.37,4.37,0,0,1,1.234-3.179,4.15,4.15,0,0,1,3.1-1.265,4.3,4.3,0,0,1,3.214,1.265,4.578,4.578,0,0,1,1.238,3.342Zm-2.1-1.654a2.1,2.1,0,0,0-.821-1.138,2.374,2.374,0,0,0-1.421-.439,2.512,2.512,0,0,0-1.54.493,2.754,2.754,0,0,0-.771,1.083Z",
    transform: "translate(-379.188 -47.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.916,50.789h1.8v1.053a2.24,2.24,0,0,1,.776-.946,1.868,1.868,0,0,1,1.061-.323,2.361,2.361,0,0,1,1.18.386l-.59,1.632a1.04,1.04,0,0,0-.817-.326,1.422,1.422,0,0,0-1,.746,5.483,5.483,0,0,0-.334,2.353l.008.408v3.383h-2.084Z",
    transform: "translate(-401.069 -47.845)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.d79d6f504c28bf0d77b90560d2fd3bb6.svg";
export { ForwardRef as ReactComponent };